import { Flex } from '@atlaskit/primitives';

import SiteSelector from './SiteSelector/SiteSelector';
import type { FunctionComponent } from 'react';
import AuthMessage from './AuthMessage/AuthMessage';
import LegalDisclaimer from './LegalDisclaimer/LegalDisclaimer';
import Scopes from './Scopes/Scopes';
import Headline from './Headline';

const EcoSystem: FunctionComponent = () => {
  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Flex alignItems="center" direction="column" gap="space.400">
        <Headline />
      </Flex>
      <SiteSelector />
      <Scopes />
      <AuthMessage />
      <LegalDisclaimer />
    </Flex>
  );
};

export default EcoSystem;
